/**
 * 企业组
 */
import groupApi from '../../api/company.group.api'

const state = {
    groupInfo: {}
};

const getters = {
};

const mutations = {
    setGroupInfo(state, data) {
        state.groupInfo = data;
    },
    clearGroup(state) {
        state.groupInfo = {};
    }
};

const actions = {
    // 获取所在企业组信息
    getGroupItem({commit}) {
        return groupApi.getGroupItem().then(res => {
            commit('setGroupInfo', res);
            return res;
        })
    },
    // 创建企业组
    createNew({commit}, name) {
        return groupApi.createNew(name);
    },
    // 更换企业组
    changeGroup({commit}, name) {
        return groupApi.changeGroup(name).then(res => {
            commit('setGroupInfo', res);
            return res;
        })
    },
    // 根据名字查找相似企业组列表
    getList({}, name) {
        return groupApi.getList(name);
    },
    // 获取组成员
    getMember({}, pageSize) {
        return groupApi.getMember(pageSize);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./app/store/modules/company.group.js